import React from "react";
import { withRouter } from "react-router";
import {
  DEFAULT_PIC,
  NO_DATA_FOUND,
  getDashboardPath,
} from "../../../../constants";

import format from "date-fns/format";
import { useHistory } from "react-router-dom";
import { getUserData } from "../../../../../src/utils/localStorage";
import SideMenuIcon from "../../../../components/uiElements/icons/profileIcons/SideMenuIcons";

const PatientList = ({ patients}) => {
  const fetchedPatients =  patients;
  const history = useHistory();
  const userData = getUserData();

  return (
    <>
      {fetchedPatients?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <table class="table mt-3">
          <thead>
            <tr>
              <th className="w-50">Patients</th>
              <th className="w-50">Date of birth</th>
            </tr>
          </thead>
          <tbody>
            {fetchedPatients?.map(patient => (
              <tr
                onClick={() =>
                  history.push({
                   pathname: getDashboardPath(`/patients/detail/${patient?.id}`),
                   state:{pop:true}
                })
                }
              >
                <td>
                  {patient?.is_concierge_service_patient && <div
                  style={{
                    "position": "absolute",
                    "marginLeft": "17px",
                    "marginTop": "14px"
                  }}
                  >
                    <SideMenuIcon
                    type="conciergeService"
                    className=""/>
                  </div>}
                  <img
                    src={patient?.image || DEFAULT_PIC}
                    width={35}
                    height={35}
                    style={{
                      borderRadius: "50%",
                      border: patient?.is_pcp ? "3px solid #333333" : "",
                    }}
                    alt={patient?.id}
                  />
                  <span className="pl-3">
                    {patient?.first_name} {patient?.last_name}{" "}
                    {userData?.chat_notify?.is_chat_listen &&
                      parseInt(userData?.chat_notify?.patient_user) ==
                        patient?.user && (
                        <span
                          className="is-dot-icon mb-0"
                          style={{ marginTop: "14px" }}
                        />
                      )}
                  </span>
                </td>

                <td>
                  {format(
                    new Date(patient?.date_of_birth) || new Date(),
                    "MMMM dd, yyyy"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default withRouter(PatientList);
